import { g as a } from "./useThemeProps-ee4acb93.js";
import { g as i } from "./createTheme-02ce03eb.js";
function e(t) {
  return i("MuiTypography", t);
}
const o = a("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]), g = o;
export {
  e as g,
  g as t
};
